define("ROOM4.CCAWebComponentsLibrary.CCAWebComponentsLibrary", [
  "Utils",
], function (Utils) {
  "use strict";

  var components = ["components/CCAReadMore.js"];

  return {
    mountToApp: function mountToApp(container) {
      var Environment = container.getComponent("Environment");
      if (Environment.isPageGenerator()) {
        return;
      }
      if (!window.customElements) {
        console.warn(
          "Web Components are not supported in this browser. Please include a polyfill to ensure proper functionality."
        );
        return;
      }

      components.forEach(function (componentFileName) {
        var script = document.createElement("script");
        script.src = Utils.getAbsoluteUrl(
          getExtensionAssetsPath(componentFileName)
        );
        script.type = "text/javascript";
        script.async = true;
        document.head.appendChild(script);
      });
    },
  };
});
